module.exports = __webpack_public_path__ + "img/blueTop.01ee8508.png";